export const timeoutError = {
  timeout: 'タイムアウトしました。',
  reLogin: 'ログインしなおしてください。',
}
